import React from 'react';
import { Navigation } from 'lucide-react';
import { resolveUrl, googleMapsUrl, wazeUrl } from './driverUtils';
import { JobAddressLinks } from '../AddressLinks';
import { addrLine } from '../travel/TravelLegs';

export const NavButtons = ({ job }) => {
  const from = addrLine(job, 'from');
  const to = addrLine(job, 'to');
  if (!from && !to) return null;
  const btn = 'h-11 px-3 rounded-md text-sm font-bold inline-flex items-center gap-1.5 border';
  return (
    <div className="flex flex-wrap gap-2" data-testid={`job-nav-${job.ref}`}>
      <a href={googleMapsUrl(from, to)} target="_blank" rel="noreferrer" className={`${btn} bg-white border-slate-200 text-[color:var(--mv-navy)] hover:border-blue-500`} data-testid={`job-nav-google-${job.ref}`}>
        <Navigation className="w-4 h-4 text-blue-600" /> Google Maps route
      </a>
      {from && (
        <a href={wazeUrl(from)} target="_blank" rel="noreferrer" className={`${btn} bg-white border-slate-200 text-[color:var(--mv-navy)] hover:border-sky-400`} data-testid={`job-nav-waze-pickup-${job.ref}`}>
          Waze · pickup
        </a>
      )}
      {to && (
        <a href={wazeUrl(to)} target="_blank" rel="noreferrer" className={`${btn} bg-white border-slate-200 text-[color:var(--mv-navy)] hover:border-sky-400`} data-testid={`job-nav-waze-dropoff-${job.ref}`}>
          Waze · drop-off
        </a>
      )}
    </div>
  );
};

export const PhotoRow = ({ photos, testid }) => {
  if (!photos?.length) return null;
  return (
    <div className="flex gap-2 overflow-x-auto pb-1" data-testid={testid}>
      {photos.map((p, i) => {
        const src = resolveUrl(typeof p === 'string' ? p : p.url);
        return (
          <a key={src + i} href={src} target="_blank" rel="noreferrer" className="shrink-0">
            <img src={src} alt={`photo ${i + 1}`} className="w-20 h-20 object-cover rounded-md border border-slate-200" />
          </a>
        );
      })}
    </div>
  );
};

export const CustomerInfo = ({ job }) => {
  if (!job.notes && !job.photos?.length && !job.staff_notes && !job.from_address && !job.to_address && !job.from_house_number && !job.to_house_number) return null;
  return (
    <div className="space-y-2" data-testid={`job-info-${job.ref}`}>
      {(job.from_address || job.to_address || job.from_house_number || job.to_house_number) && (
        <div className="rounded-md bg-slate-50 border border-slate-200 p-2">
          <strong className="text-[10px] font-black uppercase tracking-wider text-slate-500">Addresses</strong>
          <JobAddressLinks job={job} testid={`job-addresses-${job.ref}`} />
        </div>
      )}
      {job.notes && (
        <div className="text-xs rounded-md bg-slate-50 border border-slate-200 p-2 text-slate-700">
          <strong className="text-[10px] font-black uppercase tracking-wider text-slate-500">Customer note</strong>
          <div className="mt-0.5 whitespace-pre-wrap">{job.notes}</div>
        </div>
      )}
      {job.staff_notes && (
        <div className="text-xs rounded-md bg-indigo-50 border border-indigo-200 p-2 text-indigo-900">
          <strong className="text-[10px] font-black uppercase tracking-wider text-indigo-700">Office note</strong>
          <div className="mt-0.5 whitespace-pre-wrap">{job.staff_notes}</div>
        </div>
      )}
      {job.photos?.length > 0 && (
        <div>
          <div className="text-[10px] font-black uppercase tracking-wider text-slate-500 mb-1">Customer's photos</div>
          <PhotoRow photos={job.photos} testid={`job-customer-photos-${job.ref}`} />
        </div>
      )}
    </div>
  );
};
